import React, { useState } from "react";

import { BookingFormTipsSection } from "@components/Result/BookingFormTipsSection";
import FormattedMessage from "@components/UI/FormattedMessage";
import Modal from "@components/UI/Modal";

function BookingFormTips(backgroundImageUrl) {
  const [isOpen, setIsOpen] = useState(false);

  const sections = [
    {
      title: <FormattedMessage id="BookingFormTips.NameTooLong" />,
      content: (
        <>
          <p>
            <FormattedMessage id="BookingFormTips.NameTooLong.line1" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.namesOnTravelDocument" />{" "}
            </strong>
            <i>
              <FormattedMessage id="BookingFormTips.NameTooLong.line2" />
            </i>
          </p>
          <p>
            <strong>
              {" "}
              <FormattedMessage id="BookingFormTips.firstName" />{" "}
              <FormattedMessage id="BookingFormTips.otherNames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.NameTooLong.line3" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.lastName" />{" "}
              <FormattedMessage id="BookingFormTips.Surnames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.NameTooLong.line4" />
          </p>
        </>
      ),
    },
    {
      title: <FormattedMessage id="BookingFormTips.NameSuffix" />,
      content: (
        <>
          <p>
            <FormattedMessage id="BookingFormTips.NameSuffix.line1" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.namesOnTravelDocument" />{" "}
            </strong>
            <i>
              <FormattedMessage id="BookingFormTips.NameSuffix.line2" />
            </i>
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.firstName" />{" "}
              <FormattedMessage id="BookingFormTips.otherNames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.NameSuffix.line3" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.lastName" />{" "}
              <FormattedMessage id="BookingFormTips.Surnames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.NameSuffix.line1" />
          </p>
        </>
      ),
    },
    {
      title: <FormattedMessage id="BookingFormTips.SpecialCharacters" />,
      content: (
        <>
          <p>
            <FormattedMessage id="BookingFormTips.SpecialCharacters.line1" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="General.example" />
              {" 1"}
            </strong>
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.namesOnTravelDocument" />{" "}
            </strong>
            <i>
              <FormattedMessage id="BookingFormTips.SpecialCharacters.line2" />
            </i>
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.firstName" />{" "}
              <FormattedMessage id="BookingFormTips.otherNames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.SpecialCharacters.line3" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.lastName" />{" "}
              <FormattedMessage id="BookingFormTips.Surnames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.SpecialCharacters.line4" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="General.example" />
              {" 2"}
            </strong>
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.namesOnTravelDocument" />{" "}
            </strong>
            <i>
              <FormattedMessage id="BookingFormTips.SpecialCharacters.line5" />
            </i>
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.firstName" />{" "}
              <FormattedMessage id="BookingFormTips.otherNames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.SpecialCharacters.line6" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.lastName" />{" "}
              <FormattedMessage id="BookingFormTips.Surnames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.SpecialCharacters.line7" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="General.example" />
              {" 3"}
            </strong>
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.namesOnTravelDocument" />{" "}
            </strong>
            <i>
              <FormattedMessage id="BookingFormTips.SpecialCharacters.line8" />
            </i>
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.firstName" />{" "}
              <FormattedMessage id="BookingFormTips.otherNames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.SpecialCharacters.line9" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.lastName" />{" "}
              <FormattedMessage id="BookingFormTips.Surnames" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.SpecialCharacters.line10" />
          </p>
        </>
      ),
    },
    {
      title: <FormattedMessage id="BookingFormTips.OtherScenarios" />,
      content: (
        <>
          <p>
            <FormattedMessage id="BookingFormTips.OtherScenarios.line1" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.OtherScenarios.noFirstName" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.OtherScenarios.noFirstNameExample" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.OtherScenarios.noLastName" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.OtherScenarios.noLastNameExample" />
          </p>
          <p>
            <strong>
              <FormattedMessage id="BookingFormTips.OtherScenarios.oneLetterName" />
            </strong>{" "}
            <FormattedMessage id="BookingFormTips.OtherScenarios.oneLetterNameExample" />
          </p>
        </>
      ),
    },
  ];

  return (
    <>
      <div
        className={
          backgroundImageUrl
            ? "views-modal-warning-background"
            : "views-modal-warning"
        }
      >
        <strong>
          <FormattedMessage id="BookingFormTips.important" />
        </strong>{" "}
        <FormattedMessage id="BookingFormTips.notice" />
        <span
          role="button"
          className="link pointer"
          onClick={() => setIsOpen(!isOpen)}
          style={{ marginLeft: "10px" }}
        >
          <FormattedMessage id="BookingFormTips.viewTips" />
        </span>
      </div>
      <Modal
        isActive={isOpen}
        onClose={() => setIsOpen(false)}
        modalTitle={<FormattedMessage id="BookingFormTips.title" />}
      >
        <div className="view-modal">
          <div className="views-modal-description">
            <FormattedMessage id="BookingFormTips.description" />
          </div>
          <div
            className="view-modal-links-container"
            style={{
              display: "flex",
              flexDirection: "column",
              paddingTop: "10px",
            }}
          >
            {sections.map((section, index) => (
              <BookingFormTipsSection
                key={index}
                buttonText={section.title}
                content={section.content}
              />
            ))}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default BookingFormTips;
